var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseCercle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9453_3127)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#4D4D4D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 41.5V63.1667C48 66.759 45.0923 69.6667 41.5 69.6667C37.9077 69.6667 35 66.759 35 63.1667V41.5C35 37.9077 37.9077 35 41.5 35C45.0923 35 48 37.9077 48 41.5ZM69.6667 41.5V63.1667C69.6667 66.759 66.759 69.6667 63.1667 69.6667C59.5743 69.6667 56.6667 66.759 56.6667 63.1667V41.5C56.6667 37.9077 59.5743 35 63.1667 35C66.759 35 69.6667 37.9077 69.6667 41.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9453_3127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCercle);
export default __webpack_public_path__ + "static/media/pause-cercle.ea1ba957102358558f84f8d8a694af9b.svg";
export { ForwardRef as ReactComponent };